import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }



export const noOfSurveyAttemptsAction = createAsyncThunk(
    'no-of-survey-attempts',
    async (data, { rejectWithValue }) => {
        try {
            const res = await axios.get(`/support-server/api/no-of-survey-attempts?&s_date=${data?.s_date}&e_date=${data?.e_date}`)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const noOfSurveyAttemptsSlice = createSlice({
    name: 'no-of-survey-attempts',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(noOfSurveyAttemptsAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(noOfSurveyAttemptsAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(noOfSurveyAttemptsAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const noOfSurveyAttemptsReducer = noOfSurveyAttemptsSlice.reducer